import { PageWrapper } from '@/shared'

import style from './PageHeader.module.scss'

interface IProps {
    pageName: string
    pageInfo: string | null
}

export const PageHeader = (props: IProps) => {
    const { pageName, pageInfo } = props
    return (
        <PageWrapper>
            <div className={style.container}>
                <span>{pageName}</span>
                {pageInfo && <span>{pageInfo}</span>}
            </div>
        </PageWrapper>
    )
}
